
import MainScreen from './Components/MainScreen.js';

function App() {
  
return (
  <MainScreen />
);
}

export default App;
